import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, AwardIcon, StarIcon, HeartIcon } from 'lucide-react';
const badges = [{
  icon: AwardIcon,
  label: 'JAA Member',
  sub: 'Jewellers Assoc. of Australia'
}, {
  icon: ShieldCheckIcon,
  label: 'NCJV Accredited',
  sub: 'Certified Valuers Body'
}, {
  icon: StarIcon,
  label: 'GIA Certified',
  sub: 'Diamond grading'
}, {
  icon: HeartIcon,
  label: 'Lifetime Care',
  sub: 'Included on every piece'
}];
export function Accreditations() {
  return <section className="bg-paper border-y border-gold/15" data-id="element-20">
      <div className="container-custom py-10 md:py-12" data-id="element-21">
        <p className="text-center brand-mark text-[0.65rem] uppercase text-muted mb-7" data-id="element-22">
          Accredited · Certified · Trusted
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-gold/20 border border-gold/20" data-id="element-23">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.06
        }} className="bg-paper flex flex-col items-center text-center py-7 px-4 hover:bg-surface transition-colors" data-id="element-24">
              <badge.icon className="w-7 h-7 text-gold-dark mb-3" strokeWidth={1.25} data-id="element-25" />
              <p className="font-serif text-base md:text-lg text-primary leading-tight" data-id="element-26">
                {badge.label}
              </p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-muted mt-1.5" data-id="element-27">
                {badge.sub}
              </p>
            </motion.div>)}
        </div>
        <p className="text-center text-xs text-muted italic mt-5" data-id="element-28">
          [VERIFY] · Confirm current memberships and certifications with client
          before publishing.
        </p>
      </div>
    </section>;
}